import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'

export const withdrawSchema = z.object({
  /** Withdrawal id in Binance, e.g. `"b6ae22b3aa844210a7041aee7589627c"` */
  id: z.string(),
  /** withdrawal amount, e.g. `"8.91000000"` */
  amount: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** transaction fee, e.g. `"0.004"` */
  transactionFee: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** e.g. `"USDT"` */
  coin: z.string(),
  status: z.number(),
  /** e.g. `"0x94df8b352de7f46f64b01d3666bf6e936e44ce60"` */
  address: z.string(),
  /** withdrawal transaction id, e.g. `"0xb5ef8c13b968a406cc62a93a8bd80f9e9a906ef1b3fcf20a2e48573c17659268"` */
  txId: z.string(),
  /** UTC time, e.g. `"2019-10-12 11:12:02"` */
  applyTime: z.string().transform((v) => new Date(`${v}Z`).getTime()),
  /** e.g. `"ETH"` */
  network: z.string(),
  /** 1 for internal transfer, 0 for external transfer */
  transferType: z.union([z.literal(0), z.literal(1)]),
  /** will not be returned if there's no withdrawOrderId for this withdraw. e.g. `"WITHDRAWtest123"` */
  withdrawOrderId: z.string().optional(),
  /** reason for withdrawal failure, e.g. `The address is not valid. Please confirm with the recipient` */
  info: z.string().optional(),
  /** confirm times for withdraw, e.g. `3` */
  confirmNo: z.number().optional(),
  /** 1: Funding Wallet 0:Spot Wallet */
  walletType: z.union([z.literal(0), z.literal(1)]),
  txKey: z.string().optional(),
  /** complete UTC time when user's asset is deduct from withdrawing, only if status =  6(success), e.g. `"2023-03-23 16:52:41"` */
  completeTime: z
    .string()
    .transform((v) => new Date(`${v}Z`).getTime())
    .optional(),
})

export type Withdraw = z.infer<typeof withdrawSchema>
